/**
 @author xcf
 @date 2020/6/28 2:53 下午
 */
import {
    btnList
} from "../../../createScreen/script/comChart";
//


let chilCharts = [];
btnList.map((item, index) => {
    chilCharts.push({
        name: '按钮' + (index + 1),
        //多维分析图标
        ordImg: item.img,
        //大屏图标
        bigImg: item.img,
        //默认配置
        chartParam: {
            background: item.img,
        },
        //维度配置
        wdParam: {},
        //度量配置
        dlParam: {},
    })
});

export default {
    //类型
    type: 'btn',
    //类别
    class: 'elem',
    //组件名称
    name: '按钮',
    //图标
    iconImg: '/image/viewElement/btn.png',
    //大屏图标
    bigIconImg: '/image/viewElement/btn.png',
    //是否在多维分析展示
    viewType: false,
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 1,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 1,
        //最大度量数量
        maxDLLength: 1,
        //高
        dp_height: 100,
        //宽
        dp_wight: 200,
        //最小高
        dp_min_height: 50,
        //宽宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: false,
        //是否展示度量配置
        isDlConfig: false,
        //是否展示JSON配置
        isJSONConfig: false,
        //是否展示公共配置
        isComConfig: false,
        //是否展示边框
        isComBorder: false,
    },
    component: () => import('./component/btnCom.vue'),
    // 子集展示的配置项
    chilCharts: chilCharts,
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
    //度量参数
    dlHandle(option) {
        return {}
    },
    //配置参数
    params(option) {
        return {
            background: '',
            font: {
                color: '#fff',
                fontFamily: '宋体',
                fontSize: '20',
                fontWeight: '100',
                align: 'center',
                centent: '新建按钮',
            },
            push: {
                type: true,
                url: '空',
            },
            pop: {
                show: true,
                layer: [{
                    id: '空',
                    name: '空',
                }],
            }
        }
    },
    //配置组件列表
    configModule: [{
            name: '按钮配置',
            component: () => import('./config/btn_config.vue'),
        },
        {
            name: '跳转配置',
            component: () => import('../../comConfig/comPush/comPush.vue'),
        },
        {
            name: '弹窗配置',
            component: () => import('../../comConfig/comPop/comPop.vue'),
        }
    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: '',
        //接口参数
        params: {},
        //引用的组件
        jsonPonent: null,
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {

    },
    //切换图表之前的回调
    renderBefore(chart, nowChart) {

    },
    //渲染
    rendering(chart, nowChart, dom) {

    }

};